import { type SyntheticEvent, useState } from "react";

type Props = {
	selectedFilesToAdd: File[];
	setSelectedFilesToAdd: Function;
};

export const useUploadFiles = ({
	selectedFilesToAdd,
	setSelectedFilesToAdd,
}: Props) => {
	const [isDragging, setIsDragging] = useState(false);

	const handleClose = (event?: SyntheticEvent, reason?: string) => {
		if (reason === "clickaway") {
			return;
		}
	};

	const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
		const files = event.target.files ? Array.from(event.target.files) : [];

		if (files.length >= 1) {
			const newFiles = [...selectedFilesToAdd];
			Array.from(files).forEach((file: any) => {
				// Paso 2: check if file exist
				if (
					!selectedFilesToAdd.some(
						(selectedFile: any) => selectedFile.name === file.name,
					)
				) {
					newFiles.push(file);
				}
			});
			setSelectedFilesToAdd(newFiles);
		}
	};

	const handleDragOver = (event: any) => {
		setIsDragging(true);
		event.preventDefault();
	};

	const handleDrop = (event: any) => {
		setIsDragging(false);

		event.preventDefault();
		const files = event.dataTransfer.files;

		if (files.length >= 1) {
			const newFiles = [...selectedFilesToAdd];
			Array.from(files).forEach((file: any) => {
				// Paso 2: check if file exist
				if (
					!selectedFilesToAdd.some(
						(selectedFile: any) => selectedFile.name === file.name,
					)
				) {
					newFiles.push(file);
				}
			});
			setSelectedFilesToAdd(newFiles);
		}
	};

	return {
		handleFileSelect,
		handleDragOver,
		handleDrop,
		handleClose,
		setIsDragging,
		isDragging,
	};
};
